import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'navbar',
  templateUrl: 'navbar.component.html',
  styleUrls: ['navbar.component.css']
})
export class NavbarComponent {
  
  constructor(private router: Router) {}

  active(menu: string) {
    switch (menu) {
      case 'dashboard':
        return this.router.url.startsWith('/main/dashboard');
      case 'pending-payment-requests':
        return this.router.url.startsWith('/main/pending-payment-request');
      case 'transactions':
        return this.router.url.startsWith('/main/transaction');
      default:
        return false;
    }
  }
}